/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {translate} from "utils/utility";
import {Package} from "types/entities/Package";
import {useTranslation} from "react-i18next";
import {PackageItem} from "types/entities/PackageItem";
import {uniquePackageWithActivityItem} from "utils/packageUtils";

interface PackagePersonsType {
    packageDetail: Package;
}

interface PackageItemProps {
    packageItem: PackageItem;
}

const PackageDetailPackageItem = (props: PackageItemProps) => {
    const {t} = useTranslation();
    return (
        <div
            key={props.packageItem.id}
            className={"flex flex-col border-2 border-dotted border-primary-800 bg-white  flex-grow sm:flex-grow-0 rounded-md overflow-hidden "}
        >
            <div className={"p-4 min-w-[140px]"}>
                <b className={"text-lg text-primary-800 "}>{translate(props.packageItem.name)}</b>
                <div className={"sr-only"}>
                    {props.packageItem.article &&
                        props.packageItem.article.race_count_total &&
                        props.packageItem.article.race_count_total > 1 &&
                        props.packageItem.article.race_count_total + "x "}
                    {props.packageItem.duration} {t("minutes")}
                </div>
                <div className={"text-sm"}>{translate(props.packageItem.description)}</div>
                {props.packageItem.image && (
                    <div className={"packageItemImage w-16 h-16 flex flex-col"}>
                        <img className={"w-full h-full object-cover"} src={props.packageItem.image} />
                    </div>
                )}
            </div>
        </div>
    );
};
const PackageDetailPackageItems = (props: PackagePersonsType) => {
    return (
        <div className={"PackageDetailPackageItems w-full justify-self-end grid grid-cols-1 lg:grid-cols-2 gap-3"}>
            {uniquePackageWithActivityItem(props.packageDetail, true).length !== 0 &&
                uniquePackageWithActivityItem(props.packageDetail, true).map(packageItem => {
                    return <PackageDetailPackageItem key={packageItem.id} packageItem={packageItem} />;
                })}
            {uniquePackageWithActivityItem(props.packageDetail, false).length !== 0 &&
                uniquePackageWithActivityItem(props.packageDetail, false).map(packageItem => {
                    return <PackageDetailPackageItem key={packageItem.id} packageItem={packageItem} />;
                })}
        </div>
    );
};
export default PackageDetailPackageItems;
